import { CgEye } from 'react-icons/cg';

import Button from '@/components/@base/button';
import { VARIANT_ENUM } from '@/components/@base/button/type';
import Container from '@/components/@base/container';
import Props from '@/components/app/product/components/@shared/section/show-more-button/type';

import localization from '@/constant/localization';

export default function ShowMoreButton({ onShowMoreClick, label, ...props }: Props) {
  return (
    <Container className='absolute right-0 -bottom-[1px] left-0 z-20 w-full px-1 md:bottom-0 md:bg-[linear-gradient(180deg,#ffffff00_0%,#ffffffe6_100%)] md:p-4'>
      <Button
        {...props}
        variant={VARIANT_ENUM.SOUL}
        className='h-[56px] w-full rounded-lg border-none bg-[#FFFFFFF2] text-sm font-bold whitespace-nowrap text-[#76767C] shadow-[0px_-20px_14px_-16px_#7E899B0F] md:m-auto md:h-[45px] md:max-w-[25%] md:gap-1.5 md:rounded-md md:border-[1px] md:border-[#E5E8EB] md:px-7 md:py-3.5 md:shadow-[0px_2px_10px_0px_#D9DBDD8A]'
        onClick={onShowMoreClick}
        Icon={<CgEye className='hidden md:block' size={17} color='#C1C3C8' />}
      >
        {label ?? localization.showMore}
      </Button>
    </Container>
  );
}
